import { Injectable, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';

import { BaseService } from './base.service';

import { StorageService } from './storage.service';
import { GUIDService } from './guid.service';

@Injectable()
export class ConfigurationService extends BaseService {

	constructor(
		private http: Http,
		private storage: StorageService
	) {
		super();
	}

	load(path: string): Promise<any> {
		console.log('configuration:load()');

		return new Promise((resolve, reject) => {
			this.http.get(path).subscribe(
				res => {
					var data = res.json();
					if (data) {
						this.storage.setAll(data);
						resolve();
					} else {
						reject({ message: 'no configuration data received from path: ' + path });
					}
				},
				(err: any) => reject(err));
		});
	}

}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/configuration.service.ts